import type { Routine } from '../../core/types/catalog'

/** Zoveel vragen uit de shop-FAQ onder de protocollen. */
export const ROUTINES_FAQ_COUNT = 4

/**
 * Het anker van de pagina: het complete protocol (soort "Compleet" in het beheer).
 * Bij meerdere het duurste. Puur.
 */
export function anchorRoutine(routines: readonly Routine[], priceOf: (r: Routine) => number): Routine | undefined {
  return routines.filter((r) => r.level === 'Compleet').sort((a, b) => priceOf(b) - priceOf(a))[0]
}
